import htmx from "htmx.org";

htmx.config.selfRequestsOnly = false;

htmx.defineExtension("disable-element", {
  // @ts-expect-error htmx
  onEvent: function (name, evt) {
    // @ts-expect-error htmx
    const elt = evt.detail.elt;
    if (name !== "htmx:beforeRequest" && name !== "htmx:afterRequest") {
      return;
    }

    const target = elt.getAttribute("hx-disable-element");
    if (!target) {
      return;
    }

    const targetElements =
      target === "self"
        ? [elt]
        : target === "form"
          ? elt.querySelectorAll("input, button, select, textarea")
          : document.querySelectorAll(target);

    for (const targetElement of targetElements) {
      if (name === "htmx:beforeRequest" && targetElement) {
        targetElement.disabled = true;
      } else if (name === "htmx:afterRequest" && targetElement) {
        targetElement.disabled = false;
      }
    }
  },
});

// @ts-expect-error htmx
window.htmx = htmx;
